import React from "react";

const SelectInput = props => {

    return (
        <select value={props.v} onChange={e => props.set(e.target.value)} className={"select select--primary " + props.className} disabled={props.disabled}>
            <option disabled selected></option>
            {props.children}
        </select>
    );
}

SelectInput.defaultProps = {

    disabled: false

}

export default SelectInput;
